module.exports = __webpack_public_path__ + "media/images/brand/logo/farworks_amoeba-8d3feb7d97c372bd52b1f53edd7c1d61.png";